import { AvatarUrlPipe } from './avatar.pipe';
import { ColorHexToRgbaPipe, MapClassPipe, MapColorPipe } from './color.pipe';
import { GlobalCheckPointPipe, globalCheckPointTransform } from './global-check-point.pipe';
import { TeamLogoUrlPipe } from './team-logo.pipe';
import { DesktopBackgroundImageUrlPipe, IsCustomizeDesktopBackgroundPipe } from './desktop-background.pipe';
import { ImagePublicPathPipe } from './image-public.pipe';

export const PIPES = [
    AvatarUrlPipe,
    ColorHexToRgbaPipe,
    MapClassPipe,
    MapColorPipe,
    GlobalCheckPointPipe,
    TeamLogoUrlPipe,
    DesktopBackgroundImageUrlPipe,
    IsCustomizeDesktopBackgroundPipe,
    ImagePublicPathPipe
];

export {
    AvatarUrlPipe,
    ColorHexToRgbaPipe,
    MapClassPipe,
    MapColorPipe,
    GlobalCheckPointPipe,
    TeamLogoUrlPipe,
    globalCheckPointTransform,
    DesktopBackgroundImageUrlPipe,
    IsCustomizeDesktopBackgroundPipe,
    ImagePublicPathPipe
};
